class MapSet extends Map {
  constructor(object, ...rest) {
    super(object, ...rest)
  }

  toObject() {
    const object = {}
    this.forEach((value, key) => (object[key] = value))
    return object
  }
}

export default MapSet
